import { httpsCallable } from 'firebase/functions';
import { functions } from '..';

export const mapWalletToDiscord = httpsCallable<unknown, unknown>(
	functions,
	'mapWalletToDiscord'
);
